// Whether sending this text would be read as a typed "/command": the ONE test, shared by the
// composer's send path and by anything that places text into a draft from outside it.
// trim() drops what the composer drops: spaces, tabs, newlines, NBSP, U+2028/2029, U+3000, BOM.
export function beginsAsCommand(text: string): boolean {
  return text.trim().startsWith("/");
}
